import { fetchSalvarDadosCadastrais } from 'store/fetchActions/fetchDadosCadastrais';
import {
  formatarDadosCadastraisFisicaFrontToBack,
  formatarDadosCadastraisJuridicaFrontToBack,
  formatterDadosCadastraisBackToFront,
} from 'utils/formatter/dadosCadastrais';
import { ALERTA, ENUM_TIPO_PESSOA, MSG_SALVAR_DADOS_CADASTRAIS_SUCESSO } from 'utils/consts';
import { visualizarContribuinte } from 'routes/paths';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { duckDadosCadastraisDetalhar } from 'store/ducks/dadosCadastrais';

export const submitDadosCadastraisInput = (dadosInputs, user) => dispatch => {
  return new Promise((resolve, reject) => {
    const dadosFormatados = [
      formatarDadosCadastraisFisicaFrontToBack({ ...dadosInputs, tipoPessoa: ENUM_TIPO_PESSOA.fisica.descricao }),
    ];

    if (user.document_type === 'CNPJ')
      dadosFormatados.push(
        formatarDadosCadastraisJuridicaFrontToBack({
          ...dadosInputs,
          tipoPessoa: ENUM_TIPO_PESSOA.juridica.descricao,
        })
      );

    dispatch(fetchSalvarDadosCadastrais(dadosFormatados))
      .then(respostaApi => resolve(respostaApi))
      .catch(error => reject(error));
  });
};
export const editDadosCadastraisInput = (dadosInputs, user) => dispatch => {
  return new Promise((resolve, reject) => {
    const dadosFormatados = [
      formatarDadosCadastraisFisicaFrontToBack({ ...dadosInputs, tipoPessoa: ENUM_TIPO_PESSOA.fisica.descricao }),
    ];

    if (user.document_type === 'CNPJ')
      dadosFormatados.push(
        formatarDadosCadastraisJuridicaFrontToBack({
          ...dadosInputs,
          tipoPessoa: ENUM_TIPO_PESSOA.juridica.descricao,
        })
      );

    dispatch(fetchSalvarDadosCadastrais(dadosFormatados))
      .then(respostaApi => resolve(respostaApi))
      .catch(error => reject(error));
  });
};

export const sucessoRequerimento = (respostaApi, history, dispatch) => {
  dispatch(duckDadosCadastraisDetalhar(formatterDadosCadastraisBackToFront(respostaApi)));
  history.push(visualizarContribuinte);
  fetchNotificationApp(MSG_SALVAR_DADOS_CADASTRAIS_SUCESSO, null, ALERTA.SUCESSO, 'bottomRight', 10);
};
